import React, { useState } from "react";

const Contact = () => {
	const [form, setForm] = useState({ name: "", email: "", message: "" });

	const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });

	const handleSubmit = (e) => {
		e.preventDefault();
		alert("Thank you for contacting us!");
	};

	return (
		<section className="py-16" id="contact">
			<div className="max-w-4xl mx-auto px-4">
				<h3 className="text-4xl font-bold mb-6 text-yellow-500">Reach Out</h3>
				<form className="space-y-4" onSubmit={handleSubmit}>
					<input
						type="text"
						name="name"
						placeholder="Your Name"
						className="w-full p-3 border border-gray-300 rounded"
						value={form.name}
						onChange={handleChange}
						required
					/>
					<input
						type="email"
						name="email"
						placeholder="Your Email"
						className="w-full p-3 border border-gray-300 rounded"
						value={form.email}
						onChange={handleChange}
						required
					/>
					<textarea
						name="message"
						placeholder="Your Message"
						className="w-full p-3 border border-gray-300 rounded"
						rows="5"
						value={form.message}
						onChange={handleChange}
						required
					/>
					<button
						type="submit"
						className="bg-yellow-500 text-white px-6 py-3 rounded hover:bg-yellow-600 font-semibold"
					>
						Send Message
					</button>
				</form>
			</div>
		</section>
	);
};

export default Contact;
